/* KAP CUSTOM START: Dependent product options */
(() => {
  const PICKER_SELECTOR = 'variant-picker';
  const VARIANT_DATA_SELECTOR = 'data-kap-dependent-variants';
  const IMPOSSIBLE_CHECKED_SELECTOR =
    "input:checked[data-option-available='false']:not([data-variant-id])";
  const FIRST_VALID_SELECTOR =
    "input[data-option-available='true'][data-variant-id]";

  let variantMatrix;
  const pendingPickers = new Set();
  let reconciliationQueued = false;

  function getVariantMatrix() {
    if (variantMatrix) return variantMatrix;

    const dataElement = document.getElementById(VARIANT_DATA_SELECTOR);
    if (!(dataElement instanceof HTMLScriptElement)) return [];

    try {
      variantMatrix = JSON.parse(dataElement.textContent || '[]');
    } catch {
      variantMatrix = [];
    }

    return variantMatrix;
  }

  function preselectDependentOptions(event) {
    const changedOption = event.target;
    if (!(changedOption instanceof HTMLInputElement)) return;

    const changedFieldset = changedOption.closest('fieldset');
    const picker = changedFieldset?.closest(PICKER_SELECTOR);
    if (!(changedFieldset instanceof HTMLFieldSetElement) || !(picker instanceof HTMLElement)) return;

    const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
    const changedIndex = fieldsets.indexOf(changedFieldset);
    if (changedIndex < 0 || changedIndex === fieldsets.length - 1) return;

    const variants = getVariantMatrix();
    if (!variants.length) return;

    const selectedValues = fieldsets.map(
      (fieldset) => fieldset.querySelector('input:checked')?.value
    );
    selectedValues[changedIndex] = changedOption.value;

    for (let optionIndex = changedIndex + 1; optionIndex < fieldsets.length; optionIndex += 1) {
      const optionInputs = Array.from(
        fieldsets[optionIndex].querySelectorAll("input[type='radio']:not(:disabled)")
      );

      const firstCompatibleInput = optionInputs.find((input) =>
        variants.some(
          (variant) =>
            Array.isArray(variant.options) &&
            variant.options[optionIndex] === input.value &&
            variant.options
              .slice(0, optionIndex)
              .every((value, index) => value === selectedValues[index])
        )
      );

      if (!(firstCompatibleInput instanceof HTMLInputElement)) break;

      firstCompatibleInput.checked = true;
      selectedValues[optionIndex] = firstCompatibleInput.value;
    }
  }

  function reconcilePicker(picker) {
    for (const fieldset of picker.querySelectorAll('fieldset')) {
      if (!fieldset.querySelector(IMPOSSIBLE_CHECKED_SELECTOR)) continue;

      const firstValidOption = fieldset.querySelector(FIRST_VALID_SELECTOR);
      if (!(firstValidOption instanceof HTMLInputElement)) continue;

      firstValidOption.checked = true;
      firstValidOption.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
  }

  function queuePicker(picker) {
    if (!(picker instanceof HTMLElement)) return;

    pendingPickers.add(picker);
    if (reconciliationQueued) return;

    reconciliationQueued = true;
    queueMicrotask(() => {
      reconciliationQueued = false;

      for (const pendingPicker of pendingPickers) {
        if (pendingPicker.isConnected) reconcilePicker(pendingPicker);
      }

      pendingPickers.clear();
    });
  }

  function collectPickers(node) {
    if (!(node instanceof Element)) return;

    const picker = node.matches(PICKER_SELECTOR)
      ? node
      : node.closest(PICKER_SELECTOR);

    if (picker) queuePicker(picker);
    node.querySelectorAll(PICKER_SELECTOR).forEach(queuePicker);
  }

  document.addEventListener('change', preselectDependentOptions, true);
  document.querySelectorAll(PICKER_SELECTOR).forEach(queuePicker);

  new MutationObserver((records) => {
    for (const record of records) {
      collectPickers(record.target);
      record.addedNodes.forEach(collectPickers);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
/* KAP CUSTOM END: Dependent product options */
